import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import Isvg from 'react-inlinesvg'

import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import dmStorageExperimentActions from 'redux/actions/dm_storage_experiment_actions'

import handPlant from 'assets/views/dm_storage_experiment/handPlant.svg'

class DMStorageExperiment extends PureComponent {

	createAsset() {
		return (
			<div style={{
				width: '100%',
				height: '100%',
			}}
			>
				<Isvg src={handPlant} cacheGetRequests={true} />
			</div>
		)
	}

	render() {

		return (
			<FullOverlay
				title={localize('dm_storage_experiment_title')}
				strongTitle={localize('dm_storage_experiment_strong_title')}
				assetSource={this.createAsset()}
				assetWidth='250px'
				assetHeight='233px'
				primaryTextButton={localize('dm_storage_experiment_primary_text_button')}
				secondaryTextButton={localize('dm_storage_experiment_secondary_text_button')}
				primaryActionHandler={this.props.actions.doubleStorage}
				secondaryActionHandler={this.props.actions.goToMyLibrary}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		doubleStorage: dmStorageExperimentActions.doubleStorage,
		goToMyLibrary: dmStorageExperimentActions.goToMyLibrary,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(DMStorageExperiment, null, { allowMultiple: true }))
